import script from "./PageDirectMessageListing.vue?vue&type=script&setup=true&lang=js"
export * from "./PageDirectMessageListing.vue?vue&type=script&setup=true&lang=js"

import "./PageDirectMessageListing.vue?vue&type=style&index=0&id=2e459f7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e459f7f"]])

export default __exports__